import { render, staticRenderFns } from "./TheLabelMaker.vue?vue&type=template&id=c146f1e4&scoped=true&"
import script from "./TheLabelMaker.vue?vue&type=script&lang=js&"
export * from "./TheLabelMaker.vue?vue&type=script&lang=js&"
import style0 from "./TheLabelMaker.vue?vue&type=style&index=0&id=c146f1e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c146f1e4",
  null
  
)

export default component.exports